import { FC } from 'react';
import { Box, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import {
  Terms as TermsOrganism,
  TermsProps as TermsOrganismProps,
} from '@bizapp-lp/home/organisms/Terms';
import { Footer } from '@bizapp-lp/home/organisms/Footer';
import { Header, HeaderProps } from '@bizapp-lp/home/organisms/Header';

const themeColor = '#0e9499';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& *:first-child': {
        marginTop: 0,
      },
      '& .MuiTypography-h2': {
        color: themeColor,
      },
      '& .MuiTypography-h3': { color: themeColor },
    },
    headerContent: {
      textAlign: 'right',
      marginBottom: theme.spacing(7),
    },
  }),
);

export interface TermsProps
  extends TermsOrganismProps,
    Omit<HeaderProps, 'children'> {
  headerContent?: string | JSX.Element | JSX.Element[];
}

export const Terms: FC<TermsProps> = ({
  className,
  pageTitle,
  from,
  headerContent,
  children,
}) => {
  const classes = useStyles();

  return (
    <>
      <Header from={from || ''} />
      <TermsOrganism
        pageTitle={pageTitle}
        className={`${classes.root} ${className ?? ''}`}
      >
        <>
          {headerContent && (
            <Box component="section" className={classes.headerContent}>
              <Typography variant="subtitle1" component="p">
                {headerContent}
              </Typography>
            </Box>
          )}
          <Box component="section">{children}</Box>
        </>
      </TermsOrganism>
      <Footer from={from} />
    </>
  );
};
